import { fromJS } from 'immutable';

import { TypedMap } from 'utils/typed-map';

import { INIT, INIT_SUCCESS, INIT_FAILED, SET_SEARCH } from './types';

export type CausesPageState = TypedMap<{
  loading: boolean;
  error: boolean;
  search: string;
}>;

export const initialState: CausesPageState = fromJS({
  loading: false,
  error: false,
  search: '',
});

export default (
  state = initialState,
  action: {
    type: string;
    id?: string;
    value?: boolean;
    error?: Error;
    search: string;
  }
): CausesPageState => {
  switch (action.type) {
    case INIT:
      return state.set('loading', true);

    case INIT_SUCCESS:
      return state.set('loading', false);

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    case SET_SEARCH:
      return state.merge({ search: action.search });

    default:
      return state;
  }
};
